module.exports = __webpack_public_path__ + "static/media/tlyfe-video-mock-mobile.06274f50.png";